module.exports = __webpack_public_path__ + "img/16.c1b16d3e.jpg";